import type React from "react";
import { Spinner } from "./Spinner";

interface PageLoaderProps {
	/** @deprecated The loader follows the theme tokens; kept for old callers. */
	darkTheme?: boolean;
}

/**
 * Centred full-surface loader for routes with no page shape to hold yet —
 * auth handshakes, redirects, buyer-facing pages (storefront, checkout,
 * portal) and lazy chunks before the app shell exists. Dashboard pages should
 * render the matching `PageSkeleton` variant instead.
 */
export const PageLoader: React.FC<PageLoaderProps> = () => (
	<div className="loader" data-testid="page-loader">
		<Spinner size="lg" />
	</div>
);
